import { AlertCircle, RefreshCw } from 'lucide-react'

interface ErrorSectionProps {
  title?: string
  message?: string
  onRetry?: () => void
  height?: string
}

export default function ErrorSection({
  title = 'Failed to load data',
  message = 'An error occurred while fetching data.',
  onRetry,
  height = 'h-64',
}: ErrorSectionProps) {
  return (
    <div className={`bg-white rounded-lg border border-gray-200 p-6 ${height}`}>
      <div className="flex flex-col items-center justify-center h-full">
        <AlertCircle className="w-12 h-12 text-red-500 mb-3" />
        <p className="text-gray-900 font-medium mb-1">{title}</p>
        <p className="text-sm text-gray-500 text-center mb-4">{message}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
          >
            <RefreshCw className="w-4 h-4" />
            Retry
          </button>
        )}
      </div>
    </div>
  )
}
